export function QueryFactory(name, params) {
    const res = function (params) {
        return { name, params };
    };
    if (typeof params !== "undefined") {
        return res.bind(undefined, params);
    }
    return res;
}
//# sourceMappingURL=QueryFactory.js.map